import React from 'react';

interface NavbarContextProps {
  navbarOpen: boolean;
  setNavbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarContext = React.createContext<NavbarContextProps>({
  navbarOpen: false,
  setNavbarOpen: () => {}
});

export default NavbarContext;
